import { Link } from 'react-router-dom';

export default function ForMerchantsPage() {
  return (
    <div>
      {/* Hero */}
      <section style={{ background: 'var(--hero-gradient)', color: '#fff', padding: '96px 0 80px', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: '-20%', right: '-10%', width: 520, height: 520, borderRadius: '50%', background: 'radial-gradient(circle, rgba(249,115,22,0.3) 0%, transparent 70%)', pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', bottom: '-30%', left: '-10%', width: 480, height: 480, borderRadius: '50%', background: 'radial-gradient(circle, rgba(217,70,239,0.3) 0%, transparent 70%)', pointerEvents: 'none' }} />
        <div className="container" style={{ position: 'relative' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1.2fr 1fr', gap: 48, alignItems: 'center' }} className="merch-hero-grid">
            <div>
              <span className="chip" style={{ marginBottom: 20 }}>🚀 For Merchants & Brands</span>
              <h1 style={{ fontSize: 'clamp(36px, 5.4vw, 60px)', fontWeight: 800, letterSpacing: '-0.03em', lineHeight: 1.08, marginBottom: 22 }}>
                Put your brand in front of <span className="gradient-text">high-intent shoppers.</span>
              </h1>
              <p style={{ fontSize: 18, opacity: 0.86, marginBottom: 32, maxWidth: 540, lineHeight: 1.6 }}>
                Reach thousands of ready-to-buy customers across PerkVora. List your offers, track every redemption, pay only for results.
              </p>
              <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
                <Link to="/register?role=merchant" className="btn btn-primary btn-xl">
                  List your business — it's free →
                </Link>
                <Link to="/contact?topic=partnership" className="btn btn-outline-light btn-xl">
                  Talk to sales
                </Link>
              </div>
            </div>
            <div style={{ background: 'rgba(255,255,255,0.08)', borderRadius: 24, padding: 32, border: '1px solid rgba(255,255,255,0.15)', backdropFilter: 'blur(14px)' }}>
              <p style={{ fontSize: 12, fontWeight: 700, letterSpacing: '0.14em', textTransform: 'uppercase', opacity: 0.8, marginBottom: 14 }}>Merchant Dashboard Preview</p>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
                <MiniStat n="24,812" label="Impressions" />
                <MiniStat n="1,904" label="Clicks" />
                <MiniStat n="312" label="Redemptions" />
                <MiniStat n="$1,248" label="Revenue" />
              </div>
              <div style={{ background: 'rgba(0,0,0,0.25)', borderRadius: 12, padding: 16, fontSize: 13 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8, opacity: 0.75 }}>
                  <span>Top performing deal</span>
                  <span>This week</span>
                </div>
                <div style={{ fontWeight: 700, fontSize: 15 }}>20% off sitewide — SAVE20</div>
                <div style={{ fontSize: 12, opacity: 0.7, marginTop: 4 }}>184 redemptions · 9.2% conversion</div>
              </div>
            </div>
          </div>
          <style>{`@media(max-width:880px){.merch-hero-grid{grid-template-columns:1fr!important}}`}</style>
        </div>
      </section>

      {/* Why list with us */}
      <section className="section" style={{ background: '#fff' }}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: 56 }}>
            <span className="eyebrow">Why PerkVora</span>
            <h2 className="section-h2" style={{ marginTop: 12 }}>Built for real merchant outcomes</h2>
            <p className="section-lead">Other networks bury your brand next to bots and bad actors. We surface you to real, intent-driven buyers.</p>
          </div>
          <div className="grid-3">
            <Benefit icon="🎯" title="High-intent traffic" body="Our users come specifically to save on purchases — not to browse. Expect 3-5× higher conversion than display ads." />
            <Benefit icon="📊" title="Real-time analytics" body="Track impressions, clicks, redemptions, and revenue in one dashboard. Know exactly what's working and what isn't." />
            <Benefit icon="💸" title="Pay only for results" body="Start free. Pay on a performance-based model — commission per sale, not per click or impression. You're only charged when we deliver." />
            <Benefit icon="🔗" title="Works with your stack" body="Integrate with CJ, Rakuten, Impact, ShareASale, Amazon Associates, or direct tracking. No replatforming needed." />
            <Benefit icon="⚡" title="Onboarding in hours" body="Self-service portal. Submit your first deal, set your commission, and go live the same day. No 30-page contracts." />
            <Benefit icon="🛡️" title="Fraud protection built in" body="IP velocity rules, device fingerprinting, and behavioral scoring filter out bad actors before they touch your business." />
          </div>
        </div>
      </section>

      {/* How it works */}
      <section className="section section-tinted">
        <div className="container">
          <div className="text-center" style={{ marginBottom: 56 }}>
            <span className="eyebrow">Getting started</span>
            <h2 className="section-h2" style={{ marginTop: 12 }}>Live in 3 easy steps</h2>
          </div>
          <div className="grid-3" style={{ gap: 32 }}>
            <Step n="1" title="Create your merchant account" desc="Free signup. Verify your business, add your logo, set your category. Takes under 5 minutes." />
            <Step n="2" title="Submit your first deal" desc="Choose your discount type — promo code, cashback, BOGO, freebie. Set your terms, submit for quick review." />
            <Step n="3" title="Go live and track results" desc="Approved deals go live within 24 hours. Watch redemptions roll in, tweak performance, launch more." />
          </div>
        </div>
      </section>

      {/* Results callout */}
      <section className="section" style={{ background: '#fff' }}>
        <div className="container-wide">
          {/* Padding scales down on small screens — a flat 64px each side left
              almost no room for the quote at 320-360px. */}
          <div style={{ background: 'var(--brand-darker)', color: '#fff', borderRadius: 24, padding: 'clamp(24px, 5vw, 64px)', position: 'relative', overflow: 'hidden' }}>
            <div style={{ position: 'absolute', top: -60, right: -60, width: 320, height: 320, borderRadius: '50%', background: 'radial-gradient(circle, rgba(217,70,239,0.3) 0%, transparent 70%)' }} />
            {/* minmax(0, 1fr) rather than 1fr: grid items default to
                min-width:auto, so the metric labels set a floor that forced
                this card to ~440px inside a 360px viewport. */}
            <div style={{ position: 'relative', display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)', gap: 56, alignItems: 'center' }} className="results-grid">
              <div>
                <span className="eyebrow" style={{ color: '#D946EF' }}>Merchant story</span>
                <blockquote style={{ fontSize: 'clamp(22px, 2.6vw, 30px)', fontWeight: 700, letterSpacing: '-0.02em', lineHeight: 1.3, margin: '16px 0 28px' }}>
                  "We listed on PerkVora expecting modest traffic. In 30 days, we hit 4,200 redemptions — more than any other affiliate channel we've used."
                </blockquote>
                <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                  <div style={{ width: 46, height: 46, borderRadius: '50%', background: 'var(--brand-gradient)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 16 }}>D</div>
                  <div>
                    <p style={{ fontWeight: 600 }}>Danielle Torres</p>
                    <p style={{ fontSize: 13, opacity: 0.7 }}>Head of Growth, Partner Brand</p>
                  </div>
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 18 }}>
                <ResultStat n="4,200+" label="Redemptions / 30 days" />
                <ResultStat n="9.2%" label="Avg conversion rate" />
                <ResultStat n="$184k" label="Incremental revenue" />
                <ResultStat n="4.3×" label="ROAS vs. paid ads" />
              </div>
            </div>
            <style>{`@media(max-width:880px){.results-grid{grid-template-columns:1fr!important;gap:32px!important}}`}</style>
          </div>
        </div>
      </section>

      {/* Integrations */}
      <section className="section section-tinted">
        <div className="container">
          <div className="text-center" style={{ marginBottom: 40 }}>
            <span className="eyebrow">Works with your existing stack</span>
            <h2 className="section-h2" style={{ marginTop: 12 }}>Every major affiliate network. One dashboard.</h2>
          </div>
          <div className="brand-strip">
            <span>CJ Affiliate</span>
            <span>Rakuten</span>
            <span>Impact</span>
            <span>ShareASale</span>
            <span>Amazon Associates</span>
            <span>Awin</span>
            <span>Direct</span>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section">
        <div className="container">
          <div className="cta-banner">
            <h2 style={{ fontSize: 'clamp(28px, 4vw, 44px)', fontWeight: 800, letterSpacing: '-0.025em', marginBottom: 14, lineHeight: 1.1 }}>
              Ready to reach new customers?
            </h2>
            <p style={{ fontSize: 16, maxWidth: 560, margin: '0 auto 32px', opacity: 0.95 }}>Free to list. Pay only when we drive real sales. No long-term commitments, ever.</p>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/register?role=merchant" className="btn btn-xl" style={{ background: '#fff', color: '#1A1B4B', fontWeight: 700 }}>
                Start free →
              </Link>
              <Link to="/pricing" className="btn btn-outline-light btn-xl">
                See pricing
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

function Benefit({ icon, title, body }) {
  return (
    <div className="feature-tile">
      <div className="feature-icon">{icon}</div>
      <h3 className="feature-title">{title}</h3>
      <p className="feature-desc">{body}</p>
    </div>
  );
}

function Step({ n, title, desc }) {
  return (
    <div className="step-card">
      <div className="step-num">{n}</div>
      <h3 className="step-title">{title}</h3>
      <p className="step-desc">{desc}</p>
    </div>
  );
}

function MiniStat({ n, label }) {
  return (
    <div style={{ background: 'rgba(0,0,0,0.25)', borderRadius: 10, padding: 14 }}>
      <p style={{ fontSize: 22, fontWeight: 800, letterSpacing: '-0.02em', fontFamily: 'Plus Jakarta Sans, Inter, sans-serif' }}>{n}</p>
      <p style={{ fontSize: 11, opacity: 0.7, marginTop: 2, textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 600 }}>{label}</p>
    </div>
  );
}

function ResultStat({ n, label }) {
  return (
    <div style={{ background: 'rgba(255,255,255,0.08)', borderRadius: 14, padding: 24, border: '1px solid rgba(255,255,255,0.12)' }}>
      <p style={{ fontSize: 32, fontWeight: 800, letterSpacing: '-0.03em', fontFamily: 'Plus Jakarta Sans, Inter, sans-serif' }} className="gradient-text">{n}</p>
      <p style={{ fontSize: 12, opacity: 0.75, marginTop: 6, fontWeight: 500 }}>{label}</p>
    </div>
  );
}
